import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';

import AssignmentIcon from '@material-ui/icons/Assignment';
import Description from '@material-ui/icons/Description';
import FolderShared from '@material-ui/icons/FolderShared';
import Ballot from '@material-ui/icons/Ballot';
import Divider from '@material-ui/core/Divider';

export const mainListItems = (
  <div>
    <ListItem button   >
      <ListItemIcon>
        <FolderShared />
      </ListItemIcon>
      <ListItemText primary="Mis Datos" />
    </ListItem>
    <ListItem button >
      <ListItemIcon>
        <Ballot />
      </ListItemIcon>
      <ListItemText primary="Mis Cuentas" />
    </ListItem>


  </div>
);

/*
  <ListItem button>
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Customers" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <BarChartIcon />
      </ListItemIcon>
      <ListItemText primary="Reports" />
    </ListItem>
    */


export const secondaryListItems = (
  <div>

    <ListItem disabled button>


      <ListSubheader >Consultas</ListSubheader>
    </ListItem>

    <ListItem button>
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Resumen" />
    </ListItem>

    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Matriz por horas" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Resumen por días" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Resumen por meses" />
    </ListItem>
    <Divider />

    <ListItem disabled button>
      <ListSubheader >Documentos</ListSubheader>
    </ListItem>

    <ListItem button onClick={() => window.open("http://apolo.creg.gov.co/Publicac.nsf/1c09d18d2d5ffb5b05256eee00709c02/83b41035c2c4474f05258243005a1191?OpenDocument", "_blank")}>
      <ListItemIcon>
        <Description />
      </ListItemIcon>
      <ListItemText primary="Res No. 030 DE 2018" />
    </ListItem>



  </div>
);
